import Phaser from "phaser";

export type MoveDustOpts = {
  scene: Phaser.Scene;
  /** Local or world X (local when `parent` is set). */
  x: number;
  /** Local or world Y (local when `parent` is set). */
  y: number;
  /** Foot-scale multiplier (1 ≈ party unit). */
  scale?: number;
  /** Fill alpha (party default 0.4; bosses often softer). */
  alpha?: number;
  /**
   * When set, dust is a child of this container (inherits unit depth;
   * stays under body if added before body in child order).
   */
  parent?: Phaser.GameObjects.Container;
  /** World depth when not parenting (ground-adjacent). */
  depth?: number;
};

/**
 * Tiny foot dust puff for walking units. Budget/cooldown belong to the caller
 * (UnitRig trailBudget + trailCd).
 */
export function spawnMoveDust(opts: MoveDustOpts): Phaser.GameObjects.Ellipse {
  const s = Math.max(0.35, Math.min(6, opts.scale ?? 1));
  const a =
    opts.alpha != null && Number.isFinite(opts.alpha)
      ? Math.max(0.05, Math.min(0.8, opts.alpha))
      : 0.4;
  const w = 7 * s;
  const h = 5 * s;
  const puff = opts.scene.add.ellipse(opts.x, opts.y, w, h, 0x8a93a8, a);
  if (opts.parent) {
    opts.parent.addAt(puff, 1);
  } else if (opts.depth != null) {
    puff.setDepth(opts.depth);
  }
  opts.scene.tweens.add({
    targets: puff,
    alpha: 0,
    scaleX: 1.55,
    scaleY: 1.35,
    y: opts.y - 3 * s,
    duration: 260,
    ease: "Cubic.easeOut",
    onComplete: () => puff.destroy(),
  });
  return puff;
}
